<template>
  <div id="app" class="d-flex flex-column">
    <mdb-alert color="warning" v-if="demoAlert">
      <div class="d-flex flex-row justify-content-between">
        <div style="text-align: left">
          Hereby we demonstrate Bridge8 calculator based on rates provided by our partner <a href="http://www.globalgsagroup.com/office/russia/?language=English" target="_blank">FF Cargo</a>  (exclusive agent of the majority of airlines in Russia).
          All rates are valid since December, 1 2020 until further notice.
          All rates are subject of availability and provided for demo purposes only.
          <hr/>
          Interested?
          Contact <a href="mailto:sales@bridge8.tech">sales@bridge8.tech</a> and get your own free demo and Holiday discounts.
          <hr/>
          <div style="font-size: 60%">Demo limitation:
            <br>
            <ul>
              <li>1. Origins available: SVO, DME, VKO, ZIA, LED.</li>
              <li>2. Destinations available: AAQ, ABJ, ABV, ABZ, ACC, ADD, AER, ARH, ASM, ATL, AYT, BAH, BEY, BHX, BJM, BKK, BKO, BLR, BLZ, BOM, BRU, BZV, CAI, CAN, CDG, CEK, CGK, CKY, COO, CPT, CTU, DAR, DEL, DFW, DLA, DMM, DOH, DSS, DXB, EBB, EBL, ESB, EWR, EZE, FIH, FRA, GBE, GDZ, GLA, GRU, GVA, GYD, HGA, HKG, HRE, IAD, ICN, IKA, IST, ISU, JED, JFK, JIB, JNB, JRO, JUB, KAN, KGD, KGL, KHV, KIX, KJA, KRR, KRT, KUF, KUL, KWI, KZN, LAD, LAX, LBV, LED, LFW, LHR, LLW, LOS, LUN, MAN, MBA, MCT, MGQ, MMK, MNL, MPM, MRU, MRV, NBO, NCL, NDJ, NIM, NRT, NSI, OMS, ORD, OUA, OVB, PEE, PEK, PHC, PNR, PVG, REN, ROV, RUH, SCW, SEZ, SFO, SGC, SHJ, SIN, SIP, SSG, STN, SVO, SVX, SZX, TJM, TNR, TSN, UFA, VIE, VKO, VVO, WDH, XIY, YYZ, ZNZ.</li>
              <li>3. Airlines available: ET, FV, OZ, W5, U3.</li>
              <li>4. «Point on map» and «Alternative» features are not available in demo mode.</li>
            </ul>
          </div>
        </div>
        <div>
          <mdb-btn rounded size="sm" gradient="aqua" @click="demoAlert = false">Get Started</mdb-btn>
        </div>
      </div>
    </mdb-alert>
    <Header />
    <div id="content" class="flex-grow-1 d-flex flex-column pt-4">
      <router-view />
    </div>
    <text-area-modal/>
    <confirmation-modal/>
    <price-modal/>
    <loading
      :show="loader > 0"
      :label="Object.values(labels).join('<br />')"
      loader-class="loader"
    />
  </div>
</template>

<script>
import { mdbAlert, mdbBtn } from 'mdbvue'
import Header from './components/Header'
import TextAreaModal from './components/TextAreaModal'
import { mapState } from 'vuex'
import Loading from 'vue-full-loading'
import ConfirmationModal from './components/ConfirmationModal'
import PriceModal from './components/PriceModal'

export default {
  name: 'App',
  data () {
    return {
      demoAlert: true
    }
  },
  computed: {
    ...mapState({
      loader: state => state.loader,
      labels: state => state.loaderLabels
    })
  },
  components: {
    mdbAlert,
    mdbBtn,
    ConfirmationModal,
    Header,
    TextAreaModal,
    Loading,
    PriceModal
  }
}
</script>

<style lang="sass">
#app
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50
  height: 100vh
  overflow: auto

  #content
    /*overflow: hidden*/
    margin: auto
    width: 90%

html
  height: 100%

body
  min-height: 100%
  overflow: visible
  line-height: 1.2

.loader
  position: absolute
  display: inline-block
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)

.md-form .form-control
  border-bottom-color: black!important

.nav-link
  color: lightcyan!important

  &.active
    color: cyan!important

.btn
  color: black!important

  &:hover
    color: white!important

.calc-rates-bridge8-select
  .form-control
    color: whitesmoke!important
    border-bottom-color: whitesmoke!important

  .md-form
    label
      color: cyan!important

    &.select-dropdown
      margin: 0!important

.navbar
  .dropdown-menu
    form
      max-width: 17rem!important

.no-margin-select
  .select-wrapper
    margin: 0!important

    .select-dropdown
      margin: 0!important

.admin-tab-entity-properties
  .admin-tab-entity-properties-body
    input
      margin: 0

    .type-select
      input
        font-size: 14px!important

.switch
  label
    input[type=checkbox]:checked+.lever:after
      background-color: cornflowerblue

a.black-link
  color: black!important

  &:hover
    color: white!important
</style>



// WEBPACK FOOTER //
// src/App.vue